import { type Deal } from '../useDeal';

const apiToDealParamMap: { [key: string]: string } = {
  customer_id: 'contact_id',
  subscription_id: 'id',
  lead_id: 'id',
};

export const parametrizeUrl = ({
  url,
  deal,
  dealId,
}: {
  url: string | null | undefined;
  deal: Deal | undefined;
  dealId?: string;
}) => {
  const pattern = /\{.*?\}/g;

  // TODO remove after cosmic updated to new link
  if (url === '/api/deal/{subscription_id}/mileage-report') {
    url = '/portal/api/bff/deals/{subscription_id}/mileage-report';
  }

  const urlMatchesArr = url?.match?.(pattern);
  urlMatchesArr?.forEach((match) => {
    const key = match?.replace?.('{', '').replace('}', '');
    const param = apiToDealParamMap[key];
    if (param === undefined) {
      throw new Error(`Unsupported parameter in URL ${match}`);
    }

    // to ensure that we have fallback if we use url befoe deal is loaded
    const value =
      param === 'id' ? deal?.[param] || dealId : deal?.[param as keyof Deal];
    // if param is id, but value is undefined, it means that we do not yet
    // have deal id, it can happen because of nextjs router being client side
    // or deal request being in progress, but without it url does not make sense
    // and we should not fetch data
    if (value === undefined && param === 'id') {
      url = null;
    } else {
      url = url?.replace?.(match, value as string);
    }
  });

  return url;
};
